'use client';

import ImageOptimizer from '@/components/image-optimizer';
import { isExternalHref } from '@/lib/utils';
import { useBannerList } from '@/services/query/banner.query';
import { BannerPosition } from '@/services/types/banner.type';
import Link from 'next/link';

// 학원 리스트 검색창 아래 광고 배너. 반경 내 추천 실내운전연습장이 없을 때 그 자리에 노출한다.
// 추천 지점 배너와 같은 높이(PC 212px, 모바일 112px)의 틀을 쓴다.
// 모바일은 폭이 297~452px로 바뀌어 좌우가 잘리므로 광고 이미지는 452x112에 가운데 297px 안에 내용을 둔다.
// pc/mobile 각각 우선순위(sequence) 최상위 1건을 노출.
export default function SearchAdBanner() {
  const { data } = useBannerList({
    position: BannerPosition.ACADEMY_SEARCH_TOP,
  });

  const pcBanner = data?.data?.pc?.[0];
  const mobileBanner = data?.data?.mobile?.[0];

  const pcImageSrc = pcBanner?.upfilePath || mobileBanner?.upfilePath;
  const mobileImageSrc = mobileBanner?.upfilePath || pcBanner?.upfilePath;

  if (!pcImageSrc || !mobileImageSrc) return null;

  const href = pcBanner?.href || mobileBanner?.href;
  const alt = pcBanner?.title || mobileBanner?.title || '광고';

  const content = (
    <>
      <div className="desktop:block relative hidden h-[212px] w-full">
        <ImageOptimizer
          src={pcImageSrc}
          alt={alt}
          fill
          className="object-cover"
        />
      </div>
      <div className="desktop:hidden relative h-[112px] w-full">
        <ImageOptimizer
          src={mobileImageSrc}
          alt={alt}
          fill
          className="object-cover"
        />
      </div>
    </>
  );

  const linkedContent = href ? (
    isExternalHref(href) ? (
      // 외부 광고 링크: 새 탭 + SEO상 광고 표시(sponsored)
      <a
        href={href}
        target="_blank"
        rel="sponsored noopener noreferrer"
        className="block"
      >
        {content}
      </a>
    ) : (
      // 내부(자사) 링크: 클라이언트 라우팅 + follow 유지
      <Link href={href} className="block">
        {content}
      </Link>
    )
  ) : (
    content
  );

  return (
    <div className="desktop:flex desktop:justify-center">
      <aside className="desktop:web-w desktop:mt-8 desktop:w-full desktop:rounded-2xl mt-4 overflow-hidden rounded-xl">
        {linkedContent}
      </aside>
    </div>
  );
}
